import './progress_bar_modal.less';
import '../components/modal/modal.less';

import React from 'react';
import {Link, browserHistory} from 'react-router';
import {toUpperCase} from '../util/common';
import ShowError from '../components/error/show_error';
import ImageUpload from '../image_upload/image_upload';
import Map from '../components/map_component/map_component';
import Rating from '../components/rating/rating';
import fileUploadActions from '../image_upload/file_upload_actions';

class StartHandoff extends React.Component{
    constructor(props){
      super(props);
      this.state = {}
    }
    render(){
      const {state, props} = this;
      return(
        <div className = "modal-content-wrap">
          <div className="content-hdr">{props.isStartHandoff ? "Carrier Handoff" : "Package Handoff"}</div>
          <div className = "content">
            <div className = "checked-img" style = {{"backgroundImage": 'url("' + '../../public/images/account/checked-orange.svg' + '")'}}></div>
            <div className = "right-content-wrap">
              <div className = "title">{toUpperCase("meet with shipper")}</div>
              <div className = "sub-title">Meet at the agreed upon location & time</div>
            </div>
          </div>
          <div className = "content">
            <div className = "checked-img" style = {{"backgroundImage": 'url("' + '../../public/images/account/checked-orange.svg' + '")'}}></div>
            <div className = "right-content-wrap">
              <div className = "title">TAKE A PICTURE OF PACKAGE CONTENTS</div>
              <div className = "sub-title">This verifies package contents & condition</div>
            </div>
          </div>
          <div className = "content start-btn-wrap">
            <button className = "btn orange"
                    onClick = {this.props.startHandoff.bind(self,props.isStartHandoff)}>Start</button>
          </div>
          <div className = "content">
            <div className = "legal-content">Please use your discretion when carrying items.  Verify package contents are safe to carry. It is illegal to carry firearms, weapons, or illegal substances.</div>
          </div>
        </div>
      )
    }
}

class MeetShipper extends React.Component{
    constructor(props){
      super(props);
      this.state = {}
    }
    render(){
      const {state, props} = this;
      const {shipperInfo} = props;
      const imageUrl = shipperInfo.profileImgUrl || "../../public/images/user_placeholder.svg";

      return(
        <div className = "modal-content-wrap meet-shipper-modal">
          <div className="content-hdr">Meet with Shipper</div>
          <div className = "info-content">{this.props.pickupLocation}</div>
          <Map lat={props.pickupLat} lng={props.pickupLong}/>
          <div className = "content start-btn-wrap">
            <button className = "btn orange pickup-location-btn" onClick = {this.props.meetWithShipper.bind(self,props.meetWithShipper)}>
              I'm at the Pickup Location
            </button>
          </div>

          <div className = "info-header">Shipper</div>
          <div className = "shipper-info-wrap">
            <div className = "left-content-wrap">
              <div className = "shipper-info-img" style = {{"backgroundImage": 'url("' + imageUrl + '")'}}></div>
              <div className = "shipper-info">
                <div className = "name">{shipperInfo.name}</div>
                <div className="rating"><Rating rating={shipperInfo.averageRating} ratingSize={"rating-size10"}/><span className="reviewNumber">({shipperInfo.totalNoOfRatings})</span></div>
                <div className = "phone-number">{shipperInfo.phoneNumber}</div>
              </div>
            </div>
            <div className = "right-content-wrap">
              {/*<div className = "shipper-info-img" style = {{"backgroundImage": 'url("' + '../../public/images/icons_png/call.png' + '")'}}></div>*/}
              {/*<div className = "shipper-info-img" style = {{"backgroundImage": 'url("' + '../../public/images/icons_png/message.png' + '")'}}></div>*/}
            </div>
          </div>
        </div>
      )
    }
}

class UploadPicture extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  render(){
    return(
      <div className = "modal-content-wrap meet-shipper-modal">
        <div className="content-hdr">Take a picture of the package contents</div>
        <div className = "content-sub-hdr">
          Take a clear picture of the package contents for verification purposes.
        </div>
        <ImageUpload getImageUrlCallback = {this.props.onImgUpload}/>
      </div>
    )
  }
}

class HandOffDone extends React.Component{
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  render(){
    return(
      <div className = "modal-content-wrap handoff-done-modal">
        <div className="success-img" style = {{"backgroundImage": 'url("' + '../../public/images/icons_png/success.png' + '")'}}></div>
        <div className = "content-sub-hdr">
          You've successfully completed the handoff process. You may now proceed to the next step.
        </div>
        <div className = "done-button-wrap">
          <button className ="btn orange" onClick = {this.props.close}>Done</button>
        </div>
      </div>
    )
  }
}

class ProgressBarModal extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isOpen : props.isOpen,
        showMeetWithShipper: props.showMeetWithShipper,
        showUploadPicture : props.showHandOffUploadPicture,
        showSucessPopup: props.showSucessPopup,
        error: props.error,
        shipperInfo: props.shipperInfo,
        pickupLocation: props.pickupLocation,
        pickupLat: props.pickupLat,
        pickupLong: props.pickupLong
      }
      this.startHandoff = this.startHandoff.bind();
      this.meetWithShipper = this.meetWithShipper.bind();
      this.onImgUpload = this.onImgUpload.bind();
    }

    componentWillReceiveProps(newProps){
      this.setState({ isOpen:newProps.isOpen,
                      showMeetWithShipper:newProps.showMeetWithShipper,
                      error: newProps.error,
                      shipperInfo: newProps.shipperInfo,
                      showSucessPopup: newProps.showSucessPopup,
                      showUploadPicture: newProps.showHandOffUploadPicture,
                      pickupLocation: newProps.pickupLocation,
                      pickupLat: newProps.pickupLat,
                      pickupLong: newProps.pickupLong
                    })
    }
    close = () => {
      this.props.onClose();
    }

    startHandoff = (isStartHandoff) => {
      // this.setState({showMeetWithShipper:true})
      console.log("yo am there");
      this.props.startHandoff();
      // if(!isStartHandoff)
    }

    meetWithShipper = () => {
      this.props.meetWithShipper();
    }

    onImgUpload = (imgSrc) => {
      this.props.onImgUpload(imgSrc);
    }

    render() {
      const self = this;
      const {props,state} = this;
      console.log("In bar==========", props);

      let modalContent = <StartHandoff {...this.props} startHandoff = {this.startHandoff}/>;

      if(state.showSucessPopup){
        modalContent = <HandOffDone {...this.props} close = {this.close}/>
      }
      else if (state.showUploadPicture && state.showMeetWithShipper && !props.error) {
        modalContent = <UploadPicture onImgUpload = {this.onImgUpload}/>
      }
      else if(state.showMeetWithShipper && !state.error){
        modalContent = <MeetShipper
          shipperInfo = {state.shipperInfo}
          meetWithShipper={this.meetWithShipper}
          pickupLocation = {state.pickupLocation}
          pickupLat = {state.pickupLat}
          pickupLong = {state.pickupLong}
        />
      }

      return (
          <div className={state.isOpen? 'modal-popup': 'displayNone'}>
            <div className="overlay"></div>
            <div className="modal package-modal">
              {
                props.error && <ShowError errorMessage = {state.error} />
              }
              <div className="content-wrap">
                <div className="close-button">
                  <span className="icon-cross-feather cursor-pointer" onClick={this.close}></span>
                </div>
                {modalContent}
              </div>
            </div>
          </div>
        )
    }
}

export default ProgressBarModal;



// WEBPACK FOOTER //
// app/shipment/package_handoff_modal.jsx